// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__33MoA","buttons":"PendingPaymentAlert_buttons__2GHjj"};